import { Box, Typography } from '@mui/material'
import React from 'react'
import { OptionQuestion } from '../optionQuestion'
import { useStyles } from './styles'
import { QuestionData } from '../../../../../../../../service/questionarie/response'

export const QuestionCard = ({title, totalSelected, answers}:QuestionData) => {
  const styles = useStyles()
  return (
    <>
    <Box sx={styles.container}>
      <Typography sx={styles.title}>
        {`${title} ${answers[0].answersDropDown.length>1 ? ` - ${answers[0].score}` : ''}`}
      </Typography>
      {answers.map((option, index)=>(
        <OptionQuestion key={index} {...option} />))}
    </Box>
    </>
  )
}
